<template>
  <!-- zd-box 型号管理-->
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">zd-box型号管理</div>
      <div class="page-action-btns">
        <button class="common-bg-button" @click="listAddFun()" v-if="$S.checkUserMenu('pileStationAdd')">新 增</button>
        <button class="common-bg-button" @click="listEditFun()" v-if="$S.checkUserMenu('pileStationEdit')">编 辑</button>
      </div>
      <div class="list-table">
        <!-- 表格 -->
        <ZD-table
            :tableColumns="pageConfig.listColumns"
            :operates="operates"
            :tableData="tableData"
            :tableConfig="pageConfig.tableConfig"
            :selections="selections"
            v-on:updateSelections="(seals) => { selections = seals }"
        />
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData" />
      </div>
    </div>
  </div>
</template>

<script>
  import pageConfig from "./page-config";

  export default {
    data() {
      return {
        pageConfig: pageConfig, // 页面配置
        pagination: pageConfig.pagination,
        tableData: [], // 表格数据
        deviceArr:[],
        selections: [],
        queryInfo: {},
        // 列操作按钮
        operates: {
          width: 220,
          fixed: "right",
          list: [],
        },
      };
    },
    mounted() {
      // this.getSite()
      this.getListData(this.pagination, true);
    },
    methods: {
      // 数据初始化
      getListData(pagination, reload = false) {
        let _ = this;
        _.$U.showLoading(_);
        _.queryInfo.pageNum = pagination.current - 1;
        if (reload) {
          pagination.current = 1;
          _.queryInfo.pageNum = 0;
        }
        _.queryInfo.pageSize = pagination.pageSize;
        _.$H.post(_, _.$A.pilestation.getDeviceTypeList, _.queryInfo).then((res) => {
          _.tableData = res.data.data.content || [];
          _.pagination.total = res.data.data.totalElements || 0;
          _.$U.hideLoading(_);
        });
      },

      getSite() {
        let _ = this;
        _.$H.get(_, _.$A.pilestation.getDeviceType, {}).then(res => {
          _.deviceArr = res.data.data || [];
        })
      },

      // 新增
      listAddFun() {
        let _ = this;
        _.$S.listAddFun(_, pageConfig.tableEditObj);
      },

      // 编辑
      listEditFun() {
        let _ = this;
        if(_.selections.length === 0) return _.$U.error("请选择操作对象")
        _.$S.tableEditFun(_, _.selections, pageConfig.tableEditObj);
      },

      // 重置
      reset() {
        let _ = this;
        this.pagination.current = 1;
        _.queryInfo = {
          elecName: "",
          yearMon: "",
        };
        _.getListData(_.pagination, true);
      },
    },
  };
</script>

<style lang="less" scoped>

</style>
